import { ReactElement } from "react";
import * as Switch from "@radix-ui/react-switch";
import s from "./Toggle.module.css";

const Toggle = ({
  checked,
  iconChecked = null,
  iconUnchecked = null,
  classChecked = "",
  classUnchecked = "",
  disabled = false,
  ...props
}: {
  checked: boolean;
  iconChecked?: ReactElement | null;
  iconUnchecked?: ReactElement | null;
  classChecked?: string;
  classUnchecked?: string;
  disabled?: boolean;
  [key: string]: any;
}) => (
  <Switch.Root
    {...props}
    checked={checked}
    disabled={disabled}
    className={`${s.Container}`}
  >
    <Switch.Thumb
      className={`${s.Thumb} ${
        checked
          ? `${s.ThumbChecked} ${classChecked}`
          : `${s.ThumbUnchecked} ${classUnchecked}`
      } ${disabled ? "!bg-gray-600" : ""}`}
    >
      {checked && iconChecked}
      {!checked && iconUnchecked}
    </Switch.Thumb>
  </Switch.Root>
);

export default Toggle;
